import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

const categoryIcons: Record<string, string> = {
  recommended: 'ri-fire-line',
  romance: 'ri-heart-line',
  fantasy: 'ri-magic-line',
  action: 'ri-sword-line',
  comedy: 'ri-emotion-laugh-line',
  mystery: 'ri-search-eye-line',
  drama: 'ri-film-line',
  thriller: 'ri-alarm-warning-line',
  historical: 'ri-ancient-gate-line',
  all: 'ri-apps-line',
};

export default function CategorySection() {
  const displayCategories = categories.filter((c) => c.slug !== 'all');

  return (
    <section className="py-10 md:py-14 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            漫画分类
          </h2>
          <p className="text-xs md:text-sm text-foreground-500 mt-1">
            探索不同类型的韩漫，找到你的最爱
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {displayCategories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center bg-accent-100 rounded-xl group-hover:bg-accent-200 transition-colors">
                <i className={`${categoryIcons[cat.slug] || 'ri-book-open-line'} text-xl md:text-2xl text-accent-600`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.label}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}